import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NeoRol } from 'src/app/comun/models/neoRol';
import { NeoRolService } from 'src/app/comun/services/neoRol.service';
import { NeoIntermediarioFinancieroService } from '../../Service/neoIntermediarioFinanciero.service';
import { UserService } from '../../../services/user.service';
declare var $: any;

@Component({
    selector: 'app-consulta-roles-noutilizadosif',
    templateUrl: './consulta-roles-noutilizadosif.component.html',
    styleUrls: ['./consulta-roles-noutilizadosif.component.scss'],
    providers: [
        NeoRolService,
        NeoIntermediarioFinancieroService
    ],
    standalone: false
})
export class ConsultaRolesNoutilizadosifComponent implements OnInit {
  listaRoles: NeoRol[] = [];
  public user;
  mensajeError: string;
  filtroForm: UntypedFormGroup;
  listausuarios: any[] = [];
  pageActual: Number = 1;
  filtroConsulta: any = {};

  constructor(
    private _neoRolService: NeoRolService,
    private _neoIntermediarioService: NeoIntermediarioFinancieroService,
    private form: UntypedFormBuilder,
    private _neoUsuarioService: UserService) { }

  ngOnInit(): void {
    this.user = this._neoUsuarioService.getUser();
    this.filtroForm = this.form.group({
      rolesSeleccionados: ['0'],
      periodoInactividad: ['', Validators.required]
    })
    this._neoRolService.getRolesIF().subscribe(
      (result) => {
        this.listaRoles = result['roles'];
      },
      (error) => {
        this.mensajeError = 'Error al cargar los roles';
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        });
      })
  }

  consultarUsuariosRolesNoUtilizados() {
    if (this.filtroForm.value.rolesSeleccionados != '' && this.filtroForm.value.rolesSeleccionados != 0) {
      this.filtroConsulta.roles = this.filtroForm.value.rolesSeleccionados;
    }
    this.filtroConsulta.diasInactividad = this.filtroForm.value.periodoInactividad;
    this.filtroConsulta.idCliente = this._neoUsuarioService.getUser().idCliente;
    this._neoIntermediarioService.consultarRolesNoUtilizados(this.filtroConsulta).subscribe(
      (response) => {
        if (response.exitoso == true) {
          this.mensajeError = '';
          this.listausuarios = response.respuestaUsuarios;
        } else {
          this.mensaje();
        }
      }
    );
  }

  mensaje() {
    $('#mensajeModal').modal('show');
  }

  descargarExcelRoles() {
    this._neoIntermediarioService.dowloadExcelRolesNoUtilizados(this.listausuarios).
      subscribe((response: any) => {
        if (response.exitoso == true) {
          var a = document.getElementById('downloadFile');
          a.setAttribute('href', `data:${response.mimeType};base64,${response.data}`);
          a.setAttribute('download', unescape(response.fileName));
          a.click();
        }
      })
  }

  descargarTxtRoles() {
    this._neoIntermediarioService.dowloadTxtRolesNoUtilizados(this.listausuarios).
      subscribe((response: any) => {
        if (response.exitoso == true) {
          var a = document.getElementById('downloadFile');
          a.setAttribute('href', `data:${response.mimeType};base64,${response.data}`);
          a.setAttribute('download', unescape(response.fileName));
          a.click();
        }
      })
  }

  isValidForm(field: string) {
    return (
      (this.filtroForm.get(field).dirty ||
        this.filtroForm.get(field)?.touched) &&
      this.filtroForm.get(field)?.invalid
    );
  }

}
